import _ from 'lodash';
import { logStorage } from '../logger';

export interface LoginStorageData {
  managerId: string | undefined;
  trainerId: string | undefined;
  memberId: string | undefined;
  loginExpiration: number | undefined;
}

const SAVED_LOGIN_DATA_KEY = 'motivision-login-user';

export const setLoginStorageData = (loginStorageData: LoginStorageData) => {
  localStorage.setItem(SAVED_LOGIN_DATA_KEY, JSON.stringify(loginStorageData));
  logStorage('loginStorage:set', {
    hasManager: Boolean(loginStorageData.managerId),
    hasTrainer: Boolean(loginStorageData.trainerId),
    hasMember: Boolean(loginStorageData.memberId),
    expiresAt: loginStorageData.loginExpiration,
  });
};

export const getLoginStorageData = (): LoginStorageData | null => {
  const loginData = localStorage.getItem(SAVED_LOGIN_DATA_KEY);
  if (!loginData) {
    logStorage('loginStorage:get:empty');
    return null;
  }
  try {
    const parsed = JSON.parse(loginData);
    logStorage('loginStorage:get', {
      hasManager: Boolean(parsed?.managerId),
      hasTrainer: Boolean(parsed?.trainerId),
      hasMember: Boolean(parsed?.memberId),
      expiresAt: parsed?.loginExpiration,
    });
    return parsed;
  } catch (error) {
    logStorage('loginStorage:get:parse-error', { error });
    return null;
  }
};

export const clearLoginStorageData = (): void => {
  localStorage.setItem(SAVED_LOGIN_DATA_KEY, '');
  logStorage('loginStorage:clear');
};

export const isValidExpirationDate = (
  loginExpiration: number | undefined,
): boolean => {
  return _.isNumber(loginExpiration) && loginExpiration > Date.now();
};

export const hasValidLoginStorageData = (
  loginStorageData: LoginStorageData | null,
): boolean => {
  return Boolean(
    loginStorageData &&
      // isValidExpirationDate(loginStorageData.loginExpiration) &&
      (loginStorageData.memberId ||
        loginStorageData.managerId ||
        loginStorageData.trainerId),
  );
};
